import component from "containers/StaticPages/pages/Enterprise";

export default {
  key: "enterprise-join",
  title: "Enterprise",
  path: "/:user?/enterprise/:signup?/:slug?",
  pageName: "enterprise",
  component,
};
